export default "__VITE_ASSET__DDj$qTpt__"